// src/views/ControlHorarioMobile/ControlHorarioMobile.js
import { useEffect, useState, useCallback } from "react";
import moment from "moment";
import { getHours } from "../../services/newdaily";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";
import { registerLocale } from "react-datepicker";

import ViewSelector from "../../components/ViewSelector/ViewSelector";
import WeekSelector from "../../components/WeekSelector/WeekSelector";
import TurnSelector from "../../components/TurnSelector/TurnSelector";
import styles from "./ControlHorarioMobile.module.css";

registerLocale("es", es);

const weekFromDate = (dateObj) => {
  const m = moment(dateObj);
  const start = m.clone().startOf("isoWeek");
  const end = start.clone().add(6, "days");
  return { start: start.format("YYYY-MM-DD"), end: end.format("YYYY-MM-DD") };
};
const sameWeek = (a, b) => !!a && !!b && a.start === b.start && a.end === b.end;

const ControlHorarioMobile = ({ empleado, refreshSignal, isAdmin, isMobile }) => {
  const [horasEmpleado, setHorasEmpleado] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedWeek, setSelectedWeek] = useState(weekFromDate(new Date()));

  const onCalendarChange = useCallback((date) => {
    setSelectedDate(date);
    const w = weekFromDate(date);
    setSelectedWeek((prev) => (sameWeek(prev, w) ? prev : w));
  }, []);

  const onWeekChange = useCallback((newWeek) => {
    setSelectedWeek((prev) => {
      if (sameWeek(prev, newWeek)) return prev;
      setSelectedDate(moment(newWeek.start, "YYYY-MM-DD").toDate());
      return newWeek;
    });
  }, []);

  useEffect(() => {
    const fetchHoras = async () => {
      try {
        if (!empleado) return;

        const data = await getHours({ empleado });
        setHorasEmpleado(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error("Error al obtener horas del empleado:", e);
        setHorasEmpleado([]);
      }
    };

    fetchHoras();
  }, [empleado, refreshSignal]);

  const selectedDateISO = moment(selectedDate).format("YYYY-MM-DD");

  return (
    <div className={styles.mobileContainer}>
      <div className={styles.datePickerContainer}>
        <div className={styles.datePickerWrapper}>
          <DatePicker
            selected={selectedDate}
            onChange={onCalendarChange}
            locale="es"
            inline
            calendarClassName={styles.customCalendar}
          />
        </div>
      </div>

      <div className={styles.headerContainer}>
        <ViewSelector isMobile={isMobile} />
        <WeekSelector
          onWeekChange={onWeekChange}
          externalWeek={selectedWeek}
          isMobile={isMobile}
        />
      </div>

      <div className={styles.turnContainer}>
        <TurnSelector
          selectedWeek={selectedWeek}
          selectedDate={selectedDateISO}
          horasEmpleado={horasEmpleado}
          empleadoId={empleado}
          isMobile={isMobile}
        />
      </div>
    </div>
  );
};

export default ControlHorarioMobile;
